import axios from 'axios'
import { errorHandler } from '../exports/error_management'

import { StorageCache } from '../exports/dataStorage'
const storageKey = 'ams-checkoff-template-key'
const api = async (method, path, params) => axios[method](path, params)
const state = {
    selectedTemplate: {},
    templates: [],
      filter: ''
}

const mutations = {
    set_template(state, payload) {
        state.selectedTemplate = payload
    },
    set_templates(state, payload) {
        state.templates = payload
    },
    updateFilter(state, value) {
        state.filter = value;
    }
}

const actions = {
    /**
     * Set the selected template for a new template
     */
    newTemplate(context, payload) {
        context.commit('set_template', payload)
    },
    async create(context, payload) {
        try {
            const results = await api('post', `checkoff-template`, payload)
            const data = results.data.success.data
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('set_template', _data)
            storageCache.updateSelection(
                { selectionCommit, stateList: context.state.templates },
                data,
                null
            )
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetchById(context, template_id) {
        try {
            const path = `checkoff-template/${template_id}`
            console.log('checkoffTemplate fetchbyId template_id', template_id)
            const results = await api('get', path)
            console.log('checkoffTemplate fetchbyId results', results)
            context.commit('set_template', results.data.success.data)
        } catch (err) {
            console.log('err', err)
            errorHandler(err)
        }
    },

    async fetchAll(context, payload) {
        const storageCache = new StorageCache(storageKey)
        try {
            const { is_valid, value } = storageCache.getArray()
            if (!is_valid || (payload.forceReload && payload.forceReload === true)) {
                const results = await api('get', `checkoff-template`)
                const data = results.data.success.data
                storageCache.set(data)
                value.splice(0)
                value.push(...data)
            }
            context.commit('set_templates', value)
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetchAllAfterUpdate(context, payload){
         let  payload_data = payload;
        const storageCache = new StorageCache(storageKey)
        try {
            const {  value } = storageCache.getArray()
          
                const results = await api('get', `checkoff-template`)
                const data = results.data.success.data
                storageCache.set(data)
                value.splice(0)
                value.push(...data)
           
            context.commit('set_templates', value)
        } catch (err) {
            errorHandler(err)
        }
    },

    async update(context, payload) {
        console.log('update', payload)
        try {
            const results = await api(
                'put',
                `checkoff-template/${payload.id}`,
                payload
            )
            const template = results.data.success.data
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('set_template', _data)
            storageCache.updateSelection(
                { selectionCommit, stateList: context.state.templates },
                template,
                payload.id
            )
        } catch (err) {
            errorHandler(err)
        }
    },
    async delete(context, template_id) {
        try {
            await api('delete', `checkoff-template/${template_id}`)
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('set_template', _data)
            storageCache.updateSelection(
                { selectionCommit, stateList: context.state.templates },
                null,
                template_id
            )
        } catch (err) {
            errorHandler(err)
        }
    },

    async createType(context, { template_id, item }) {
        try {
            const results = await api(
                'post',
                `checkoff-template/${template_id}/types`,
                item
            )
            const template = results.data.success.data
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('set_template', _data)
            storageCache.updateSelection(
                { selectionCommit, stateList: context.state.templates },
                template,
                template_id
            )
        } catch (err) {
            errorHandler(err)
        }
    },

    async updateType(context, { template_id, item }) {
        try {
            const results = await api(
                'put',
                `checkoff-template/${template_id}/types/${item.id}`,
                item
            )
            const template = results.data.success.data
            // console.log("template",template)
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('set_template', _data)
            storageCache.updateSelection(
                { selectionCommit, stateList: context.state.templates },
                template,
                template_id
            )
        } catch (err) {
            errorHandler(err)
        }
    },

    async deleteType(context, { template_id, item_id }) {
        try {
            const results = await api(
                'delete',
                `checkoff-template/${template_id}/types/${item_id}`
            )
            const template = results.data.success.data
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('set_template', _data)
            storageCache.updateSelection(
                { selectionCommit, stateList: context.state.templates },
                template,
                template_id
            )
        } catch (err) {
            errorHandler(err)
        }
    },

    async upload(context, payload) {
        try {
            const results = await api('post', `checkoff-template/upload`, payload)
            const data = results.data.success.data
            // const storageCache = new StorageCache(storageKey)
            // const selectionCommit = _data =>
            //     context.commit('SET_SELECTED_TYPE', _data)
            // storageCache.updateSelection(
            //     {
            //         sortCompare: sortTypes,
            //         selectionCommit,
            //         stateList: context.state.types,
            //     },
            //     data,
            //     data.id
            // )
            return data
        } catch (err) {
            errorHandler(err)
        }
    },
    async exportExcelCSV(context, {query_t }) {
        try {
            query_t = query_t || '';
           
    
            const response = await  axios.get(`checkoff-template/export-excel-csv?q=${query_t}`)
            //   const blob = new Blob([response.data], {
            //     type:
            //       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            //   });
            //   const url = window.URL.createObjectURL(blob);
            //   const link = document.createElement("a");
            //   link.href = url;
            //   link.setAttribute("download", "workflow_templates.csv");
            //   document.body.appendChild(link);
            //   link.click();
            //   document.body.removeChild(link);
            //   window.URL.revokeObjectURL(url);
            const base64Data = response.data.file_data.trim();

            // Decode the Base64 string
            const binaryString = window.atob(base64Data);
            const len = binaryString.length;
            const bytes = new Uint8Array(len);

            for (let i = 0; i < len; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }

            const blob = new Blob([bytes.buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", response.data.file_name);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (err) {
          console.error("Error fetching request:", err);
        }
      },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
